<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/882My8/tc-custom/9783965371347.jpg" alt="This image is the cover for the book Kai Lung's Golden Hour, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kai Lung's Golden Hour, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>As with other Kai Lung novels, the main plot serves primarily as a vehicle for the presentation of the gem-like, aphorism-laden stories told by the protagonist Kai Lung, an itinerant story-teller of ancient China. In Kai Lung's Golden Hours he is brought before the court of the Mandarin Shan Tien on charges of treason by the Mandarin's confidential agent Ming-shu. In a unique defense, Kai Lung recites his beguiling tales to the Mandarin, successfully postponing his conviction time after time until he is finally set free. In the process he attains the love and hand of the maiden Hwa-Mei. (Wikipedia)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ernest Bramah
      </h2>
      
      <p class="authorDescription body article">Ernest Bramah (20 March 1868 – 27 June 1942), whose name was recorded after his birth as Ernest Brammah Smith, was an English author. He published 21 books and numerous short stories and features. His humorous works were ranked with Jerome K. Jerome and W. W. Jacobs. (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      otbebookpublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e370e5e